import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "@/i18n/LangContext";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        offset={84}
        toastOptions={{
          className: "!rounded-none !border-2 !border-[#0F0F10] !bg-[#F4EFE6] !text-[#0F0F10] !font-mono !shadow-[5px_5px_0_#D7192A]",
        }}
      />
    </LangProvider>
  );
}

export default App;
